module.exports = __webpack_public_path__ + "static/media/Flag.64c49f9e.svg";